module.exports = __webpack_public_path__ + "static/media/DM.a374fff4.svg";